import { Link } from 'react-router-dom';
import MovieCard from '@/components/base/MovieCard';
import { hotTVShows } from '@/mocks/movies';

export default function HotTVShowsSection() {
  const displayShows = hotTVShows.slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              热门电视剧
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              高分好剧一网打尽，超清画质流畅追剧
            </p>
          </div>
          <Link
            to="/category/drama"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {displayShows.map((show) => (
            <MovieCard
              key={show.id}
              id={show.id}
              title={show.title}
              year={show.year}
              rating={show.rating}
              genre={show.genre}
              quality={show.quality}
              imageUrl={show.imageUrl}
              isHot={show.isHot}
              isNew={show.isNew}
              linkTo={`/category/drama`}
            />
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/drama"
            className="inline-flex items-center gap-1 px-6 py-2 text-sm font-medium text-primary-500 border border-primary-200 rounded-full hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部电视剧
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}